import { AppLayout } from '@/components/AppLayout';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import InvitePage from './pages/InvitePage';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import PrivacyPage from './pages/PrivacyPage';
import PublicRecipePage from './pages/PublicRecipePage';
import SignupPage from './pages/SignupPage';
import TermsPage from './pages/TermsPage';
import AddRecipePage from './pages/app/AddRecipePage';
import AdminLogsPage from './pages/app/AdminLogsPage';
import AdminPage from './pages/app/AdminPage';
import AdminTestHarnessPage from './pages/app/AdminTestHarnessPage';
import AdminTierLimitsPage from './pages/app/AdminTierLimitsPage';
import AdminUsersPage from './pages/app/AdminUsersPage';
import BillingPage from './pages/app/BillingPage';
import FavoritesPage from './pages/app/FavoritesPage';
import HomePage from './pages/app/HomePage';
import NotificationsPage from './pages/app/NotificationsPage';
import ProfilePage from './pages/app/ProfilePage';
import RecipeBoxPage from './pages/app/RecipeBoxPage';
import RecipePage from './pages/app/RecipePage';
import SearchPage from './pages/app/SearchPage';
import SupportPage from './pages/app/SupportPage';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          
          {/* Protected routes - require auth */}
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            {/* Protected app routes */}
            <Route path="/home" element={<HomePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/recipe-box/:id" element={<RecipeBoxPage />} />
            <Route path="/recipe/:id" element={<RecipePage />} />
            <Route path="/add-recipe" element={<AddRecipePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/tier-limits" element={<AdminTierLimitsPage />} />
            <Route path="/admin/logs" element={<AdminLogsPage />} />
            <Route path="/admin/test-harness" element={<AdminTestHarnessPage />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
          </Route>

          {/* Other public routes */}
          <Route path="/invite" element={<InvitePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/share/recipe/:token" element={<PublicRecipePage />} />
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
